import Step from 'shepherd.js/src/types/step';
import { TourSteps } from './interface/tour-steps.interface';

export const createAppointmentFromConsultationStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'newAppointmentFromConsultation1',
        title: 'Agenda tu primera cita',
        text: `Da clic en el botón para comenzar a agendar una cita. No te preocupes si no tienes todos los datos ahora, para fines demostrativos del tour vamos a crear una cita DEMO, la cita será eliminada al terminar el tour.`,
        attachTo: {
          element: '.btn-add-appointment',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-add-appointment',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'newAppointmentFromConsultation2',
        title: 'Tipo de cita',
        text: `Puedes elegir entre una cita presencial o una cita en línea, selecciona la opción para continuar.`,
        attachTo: {
          element: '.appointment-type-0',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.appointment-type',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'newAppointmentFromConsultation3',
        title: 'Motivo de la cita',
        text: `Puedes agregar un motivo por el cual se llevará a cabo la cita. Este valor no es requerido y para fines del tour omitiremos este paso. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.appointment-goal',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'newAppointmentFromConsultation4',
        title: 'Objetivos clínicos',
        text: `Puedes agregar uno o varios objetivos clínicos para el paciente, sin embargo, no es requerido y para fines del tour vamos a omitir este paso. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.select-objectives',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'newAppointmentFromConsultation5',
        title: 'Sucursal',
        text: `Puedes seleccionar la sucursal en la cual el paciente tomará la cita. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.select-branch',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'newAppointmentFromConsultation6',
        title: 'Fecha de la cita',
        text: `Puedes seleccionar la fecha en la que se llevará a cabo la cita, además puedes elegir entre bloques predeterminados de fecha. Da clic para continuar.`,
        attachTo: {
          element: '.block-date-4',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.block-date-4',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'newAppointmentFromConsultation7',
        title: 'Disponibilidad para la cita',
        text: `Puedes seleccionar el horario en el cual se llevará a cabo la cita, para esto se toma en cuenta la disponibilidad de horario del experto. Para fines del tour no es necesario que selecciones el horario. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.availability-section',
          on: 'top'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'newAppointmentFromConsultation8',
        title: 'Finalizar el registro de la cita',
        text: `Da clic en el botón para guardar y agendar la cita DEMO. Para fines del tour, se eliminarán los datos de prueba generados y será redirigido al listado de pacientes.`,
        attachTo: {
          element: '.btn-save-appointment',
          on: 'top'
        },
        advanceOn: {
          selector: '.btn-save-appointment',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
        classes: undefined,
      }
    ];
  };
